import React, { useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FireDepartmentService, FirefighterService } from '../../../services';
import { useAppSelector } from '../../../store/hooks';
import { selectDepartment, selectIsAdmin, selectIsSuperAdmin } from '../../../store/reducers';
import type { FireDepartment, Firefighter } from '../../../types';
import { SimpleListItem } from '../../atoms';

export function Members(): React.JSX.Element {
  const navigate = useNavigate();
  const department = useAppSelector(selectDepartment);
  const isAdmin = useAppSelector(selectIsAdmin);
  const isSuperAdmin = useAppSelector(selectIsSuperAdmin);

  const [isLoading, setIsLoading] = React.useState(true);
  const [members, setMembers] = React.useState<Firefighter[]>([]);
  const [departments, setDepartments] = React.useState<FireDepartment[]>([]);
  const [selectedDepartment, setSelectedDepartment] = React.useState<string>('undefined');

  const loadFirefighters = async (): Promise<void> => {
    if (department || selectedDepartment !== 'undefined') {
      const firefighterResponse = await FirefighterService.getAllFirefightersOfDepartment(
        department ? department.id : selectedDepartment
      );
      if (firefighterResponse.error) {
        toast.error('Fehler beim Laden der Mitglieder 😩');
        console.log(firefighterResponse.message);

        return;
      }
      setMembers(firefighterResponse.data as Firefighter[]);
      setIsLoading(false);
    }
  };

  const loadFireDepartments = async (): Promise<void> => {
    const fireDepartmentResponse = await FireDepartmentService.getAllFireDepartments();
    if (fireDepartmentResponse.error) {
      toast.error('Fehler beim Laden der Feuerwehren 😩');
      console.log(fireDepartmentResponse.message);

      return;
    }
    setDepartments(fireDepartmentResponse.data as FireDepartment[]);
    setIsLoading(false);
  };

  const handleAddButton = () => {
    navigate('add');
  };

  useEffect(() => {
    if (isSuperAdmin) {
      loadFireDepartments().then(() => {});
    } else {
      loadFirefighters().then(() => {});
    }
  }, []);

  useEffect(() => {
    if (selectedDepartment !== 'undefined') {
      loadFirefighters().then(() => {});
    }
    if (selectedDepartment === 'undefined') {
      setMembers([]);
    }
  }, [selectedDepartment]);

  if (isLoading) {
    return <></>;
  }

  return (
    <div className={'container mt-10'}>
      {(isAdmin || isSuperAdmin) && (
        <div className='row mb-3'>
          <div className='col-12 d-flex justify-content-end'>
            <Button variant='success' onClick={handleAddButton}>
              Hinzufügen
            </Button>
          </div>
        </div>
      )}
      {isSuperAdmin && departments && (
        <div className='row mb-3'>
          <div className='col-12'>
            <Form.Select value={selectedDepartment} onChange={(e) => setSelectedDepartment(e.target.value as string)}>
              <option value='undefined'>Abteilung auswählen</option>
              {departments.map((fd) => (
                <option value={fd.id}>{fd.name}</option>
              ))}
            </Form.Select>
          </div>
        </div>
      )}
      <div className='row'>
        {members.map((member) => (
          <div className='col-12 mb-2' key={`container-${member.id}`}>
            <SimpleListItem key={member.id} link={`/mitglieder/${member.id}`}>
              {member.firstname} {member.lastname}
            </SimpleListItem>
          </div>
        ))}
      </div>
    </div>
  );
}
